// Copyright (c) 2016 Deere & Company

import './pins-not-registered-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Criteria from '../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import GeneralSettings from '@deere/cps-it.warranty-model-factory/lib/general-settings';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import PinsNotRegistered from '@deere/cps-it.warranty-model-factory/lib/pins-not-registered';
import PinsNotRegisteredReportCriteria from './pins-not-registered-report-criteria';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import View from '../state/view';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getPinsNotRegisteredColumnDefinitions} from '../report-services/column-definitions';
import {scrollToAndResizeReport} from '../../../reports/shared/services/scroll-window';

function handleModelInputChange(event) {

    const model = event.target.value;

    this.actions.updatePinsNotRegisteredCriteria('model', model);

}

function handlePinInputChange(event) {

    const pin = event.target.value;

    this.actions.updatePinsNotRegisteredCriteria('pin', pin);

}

function handleDealerSelect(index, isSelected) {

    this.actions.selectPinsNotRegisteredDealer(index, isSelected);

}

function handleSelectAllDealers() {

    this.actions.selectAllPinsNotRegisteredDealers(this.selectedAccounts);

}

function handleCreateReport() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetSearchResults();
    this.actions.createPinsNotRegisteredReport();

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'pins-not-registered';

    return exportToCSV(fileName, this.gridApi);

}

function handleReset() {

    this.actions.resetCriteria(this.selectedAccounts);
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);

}

class PinsNotRegisteredReport extends Component {

    componentWillMount() {

        this.props.actions.selectAllDealersOnLoad(this.props.selectedAccounts);
        this.props.actions.getReportLayouts('pins-not-registered');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='pins-not-registered'>
                <h2 className='pins-not-registered-title'>
                    <FormattedMessage id='PINS_NOT_REGISTERED'/>
                    <FavoriteIcon
                        id='PINS_NOT_REGISTERED'
                        route={this.props.pathName}
                    />
                </h2>
                <PinsNotRegisteredReportCriteria
                    canExport={this.props.report.length > 0}
                    canRunReport={this.props.selectedDealers.length > 0}
                    model={this.props.criteria.model}
                    onCreateReport={this.props::handleCreateReport}
                    onDealerSelect={this.props::handleDealerSelect}
                    onExportToCsv={this.props::handleExportToCsv}
                    onModelInputChange={this.props::handleModelInputChange}
                    onPinInputChange={this.props::handlePinInputChange}
                    onReset={this.props::handleReset}
                    onSelectAllDealers={this.props::handleSelectAllDealers}
                    pin={this.props.criteria.pin}
                    selectedAccounts={this.props.selectedAccounts}
                    selectedDealers={this.props.selectedDealers}
                />
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='pins-not-registered'
                            />
                            <ReportGrid
                                columnDefs={getPinsNotRegisteredColumnDefinitions()}
                                enableFilter={true}
                                gridOptions={gridOptions}
                                headerHeight='32'
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                                rowHeight='32'
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

PinsNotRegisteredReport.displayName = 'PinsNotRegisteredReport';
PinsNotRegisteredReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    generalSettings: PropTypes.instanceOf(GeneralSettings).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(PinsNotRegistered)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    views: PropTypes.arrayOf(PropTypes.instanceOf(View)).isRequired
};

export default PinsNotRegisteredReport;



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/components/pins-not-registered-report.js